import styled from "styled-components";
import { Box } from '@mui/material';

export const MessageWrap = styled(Box)`
  &.MuiBox-root{
    width: 400px;
    background-color:#FFFFFF;
    box-shadow: 24px;
    padding: 24px;
  }
`;

export const MessageBox = styled(Box)`
  &.MuiBox-root{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #49454F;
  }

  &.MuiBox-root .MuiTypography-root{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #49454F;
  }
`;

export const ButtonBox = styled(Box)`
  &.MuiBox-root{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    width:100%;
    height:64px;
    gap:8px;
  }
`;
